<template>
    <div class="flex flex-col">
        <!-- Contents -->
        <div    class="w-full">
            <select2    v-model:value="$data._featureLevel"
                        :options="$data._featureLevels"
                        placeholder="Select a Feature Level"
                        @input="setFeatureLevel"
                        :close-on-select="true"
            ></select2>
        </div>
    </div>
</template>

<script>
import axios from "axios"
import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
import {iconNamesMixin} from '@/mixins/IconNamesMixin';
import Select2 from "../elements/select2.vue";

export default {
    name: "FeatureLevelSelection",
    mixins: [SonicuCoreMixin, iconNamesMixin],
    components: {Select2},
    emits: ['update:saving', 'update:hasError'],
    props: {
        // Props
        loading: {
            type: Boolean,
            default: false,
        },
        saving: {
            type: Boolean,
            default: false,
        },
        hasError: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            // Data Properties
            _lastFeatureLevel: null,
            _featureLevel: null,
            _featureLevels: [],

            _savingFeatureLevel: false,
            _errors: [],
        }
    },
    created() {

    },
    mounted() {
        // Mounted
        this.getFeatureLevel()
    },
    methods: {
        // Methods
        getFeatureLevel() {
            // Get the feature level via route for the company
            axios.get(this.company.buildCompanyApiInternalRoute('features'))
                .then(response => {
                    this.$data._featureLevels = response.data.featureLevelOptions
                    this.$data._featureLevel = response.data.feature_level
                    this.$data._lastFeatureLevel = response.data.feature_level
                })
        },
        setFeatureLevel(featureLevel) {
            // Ensure that the feature level is not null
            if (_.isNil(featureLevel)) {
                return
            }

            // Ensure that Feature Level has changed, if not, do not save
            if (featureLevel === this.$data._featureLevel) {
                return
            }

            // Set the feature level via route for the company
            this.$data._errors = []
            this.$data._savingFeatureLevel = true
            axios.post(this.company.buildCompanyApiInternalRoute('feature-level'), {
                featureLevel: featureLevel,
            })
            .then(response => {
                this.$data._featureLevel = response.data.featureLevel
                this.$data._lastFeatureLevel = response.data.featureLevel
            }).catch(error => {
                console.log(error)
                this.$data._errors = error.response.data.errors
            }).then(() => {
                this.$data._savingFeatureLevel = false
            })
        },
    },
    computed: {},
    watch: {
        _featureLevel(val, old) {
            // Watchers
            // console.log(`Feature Level: ${newVal}  |  Old Value: ${oldVal}`)
        },
        _savingFeatureLevel(val, old) {
            this.$emit('update:saving', val)
        },
        _errors: {
            handler: function (val, old) {
                this.$emit('update:hasError', val.length > 0)
            },
            deep: true,
        },
    },
}
</script>

<style scoped>

</style>